/* =========================================================================
   KOSZYK PUFY — część 1/2: rdzeń + podgląd koszyka na hover
   Warstwa zachowań nad cart drawerem motywu Hyper (FoxTheme).
   Nie podmienia logiki koszyka.

   Ten plik udostępnia wspólną przestrzeń window.KT, z której korzysta
   koszyk-test-2.js (stopka, kod rabatowy, polityki, rekomendacje).
   Podział na dwa pliki jest celowy — ułatwia wgrywanie i czytanie.
   Kolejność ładowania w layout/theme.liquid ma znaczenie.
   ========================================================================= */

(function () {
  'use strict';

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* --- Formatowanie kwot ---------------------------------------------- */
  var fmt = null;
  function money(cents, currency) {
    try {
      if (!fmt) {
        fmt = new Intl.NumberFormat(document.documentElement.lang || 'pl', {
          style: 'currency',
          currency: currency || 'PLN'
        });
      }
      return fmt.format(cents / 100);
    } catch (err) {
      return (cents / 100).toFixed(2);
    }
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* --- Komunikat dla czytników ekranu ----------------------------------
     Motyw nie ogłasza dodania do koszyka. Osoba korzystająca z czytnika
     nie dostaje żadnej informacji zwrotnej. Dokładamy region live.        */
  var live = document.createElement('p');
  live.className = 'kt-sr';
  live.id = 'kt-live';
  live.setAttribute('role', 'status');
  live.setAttribute('aria-live', 'polite');

  function announce(msg) {
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 60);
  }

  document.addEventListener('product-ajax:added', function (e) {
    var title = (e.detail && e.detail.product && e.detail.product.title) || 'Produkt';
    announce(title + ' — dodano do koszyka.');
  });

  /* --- Kwota w przycisku „Do kasy” -------------------------------------
     SKIMS: „PLN 2 002 – Checkout”. Mniej niespodzianek na kolejnym kroku. */
  function priceInCheckoutButton() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    var total = drawer.querySelector('.totals__subtotal-value');
    var btn   = drawer.querySelector('.drawer__footer-buttons .btn--primary .btn__text');
    if (!total || !btn) return;

    var amount = total.textContent.trim();
    if (!amount) return;

    var base = btn.getAttribute('data-kt-base');
    if (!base) {
      base = btn.textContent.trim();
      btn.setAttribute('data-kt-base', base);
    }
    btn.textContent = base + ' · ' + amount;
  }

  /* --- Puls licznika w nagłówku ---------------------------------------- */
  function bumpCount() {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.style.transition = 'transform .35s cubic-bezier(0,0,.2,1)';
      el.style.transform = 'scale(1.3)';
      setTimeout(function () { el.style.transform = 'scale(1)'; }, 180);
    });
  }

  /* --- Focus na przycisku zamykania po otwarciu ------------------------ */
  document.addEventListener('drawer:handleAfterShow', function (e) {
    if (!e.target || e.target.tagName !== 'CART-DRAWER') return;
    var x = e.target.querySelector('.drawer__close-btn');
    if (x) x.focus({ preventScroll: true });
  }, true);

  /* --- Przeliczenie szerokości paska przewijania przy resize -----------
     Motyw liczy --scrollbar-width tylko raz, przy DOMready. Po obrocie
     ekranu albo zmianie okna treść drga przy otwieraniu panelu.          */
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      if (document.body.classList.contains('modal-show')) return;
      var w = window.innerWidth - document.body.clientWidth;
      if (w > 0) document.documentElement.style.setProperty('--scrollbar-width', w + 'px');
    }, 150);
  });

  /* =======================================================================
     PODGLĄD KOSZYKA NA HOVER
     Mała karta pod ikoną koszyka: nazwa, wariant, ilość, cena, suma.
     Tylko myszka i tylko desktop — dotyk nie ma hovera, a na wąskim
     ekranie karta i tak zasłoniłaby pół strony.
     ===================================================================== */

  var PEEK_MAX  = 3;      // ile pozycji pokazać zanim zwiniemy w „+N”
  var DELAY_IN  = 180;    // ms — żeby nie migało przy przejeżdżaniu myszką
  var DELAY_OUT = 260;    // ms — czas na przejechanie kursorem z ikony na kartę

  var peek, peekTimerIn, peekTimerOut, fetching = null;
  var state = { cartCache: null };

  function canHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches
        && window.innerWidth >= 990;
  }

  function getCart() {
    if (state.cartCache) return Promise.resolve(state.cartCache);
    if (fetching) return fetching;
    fetching = fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { state.cartCache = c; fetching = null; return c; })
      .catch(function () { fetching = null; return null; });
    return fetching;
  }

  function buildPeek() {
    if (peek) return peek;
    peek = document.createElement('div');
    peek.className = 'kt-peek';
    peek.id = 'kt-peek';
    peek.setAttribute('role', 'presentation');   // treść jest też w drawerze
    peek.hidden = true;
    peek.addEventListener('mouseenter', cancelHide);
    peek.addEventListener('mouseleave', scheduleHide);
    document.body.appendChild(peek);
    return peek;
  }

  function renderPeek(cart) {
    var el = buildPeek();

    if (!cart || !cart.item_count) {
      el.innerHTML = '<p class="kt-peek__empty">Koszyk jest pusty</p>';
      return;
    }

    var shown = cart.items.slice(0, PEEK_MAX);
    var rest  = cart.item_count - shown.reduce(function (a, i) { return a + i.quantity; }, 0);

    var rows = shown.map(function (it) {
      var img = it.image
        ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_80x$1$2') + '" alt="" width="40" height="40" loading="lazy">'
        : '<span class="kt-peek__ph"></span>';
      var variant = (it.variant_title && it.variant_title !== 'Default Title')
        ? '<span class="kt-peek__variant">' + esc(it.variant_title) + '</span>'
        : '';
      return '<li class="kt-peek__item">' +
               img +
               '<span class="kt-peek__text">' +
                 '<span class="kt-peek__name">' + esc(it.product_title) + '</span>' +
                 variant +
               '</span>' +
               '<span class="kt-peek__price">' +
                 (it.quantity > 1 ? '<span class="kt-peek__qty">' + it.quantity + ' × </span>' : '') +
                 money(it.final_price, cart.currency) +
               '</span>' +
             '</li>';
    }).join('');

    el.innerHTML =
      '<ul class="kt-peek__list">' + rows + '</ul>' +
      (rest > 0 ? '<p class="kt-peek__more">+ ' + rest + ' w koszyku</p>' : '') +
      '<div class="kt-peek__foot">' +
        '<span>Razem</span>' +
        '<strong>' + money(cart.total_price, cart.currency) + '</strong>' +
      '</div>';
  }

  function position(trigger) {
    var el = buildPeek();
    var r = trigger.getBoundingClientRect();
    el.hidden = false;                      // trzeba zmierzyć
    var w = el.offsetWidth || 300;
    var left = Math.min(Math.max(12, r.right - w), window.innerWidth - w - 12);
    el.style.top  = (r.bottom + 10) + 'px';
    el.style.left = left + 'px';
  }

  function showPeek(trigger) {
    if (!canHover()) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.hasAttribute('open')) return;   // panel otwarty — nie dubluj

    getCart().then(function (cart) {
      renderPeek(cart);
      position(trigger);
      requestAnimationFrame(function () { peek.setAttribute('data-on', ''); });
    });
  }

  function hidePeek() {
    if (!peek) return;
    peek.removeAttribute('data-on');
    setTimeout(function () {
      if (peek && !peek.hasAttribute('data-on')) peek.hidden = true;
    }, 200);
  }

  function scheduleHide() {
    clearTimeout(peekTimerIn);
    clearTimeout(peekTimerOut);
    peekTimerOut = setTimeout(hidePeek, DELAY_OUT);
  }
  function cancelHide() {
    clearTimeout(peekTimerOut);
  }

  function bindTrigger(el) {
    if (!el || el.dataset.ktPeekBound) return;
    el.dataset.ktPeekBound = '1';

    el.addEventListener('mouseenter', function () {
      cancelHide();
      clearTimeout(peekTimerIn);
      peekTimerIn = setTimeout(function () { showPeek(el); }, DELAY_IN);
    });
    el.addEventListener('mouseleave', scheduleHide);
    el.addEventListener('focus', function () { showPeek(el); });
    el.addEventListener('blur', scheduleHide);
    // klik nadal otwiera pełny panel — podgląd tylko schodzi z drogi
    el.addEventListener('click', hidePeek);
  }

  function bindAll() {
    document.querySelectorAll('.cart-drawer-button, [aria-controls="CartDrawer"].cart-icon')
      .forEach(bindTrigger);
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hidePeek(); });
  window.addEventListener('scroll', hidePeek, { passive: true });
  window.addEventListener('resize', hidePeek);

  /* --- Wspólna przestrzeń dla części 2 --------------------------------- */
  window.KT = {
    ROOT: ROOT,
    state: state,
    money: money,
    esc: esc,
    announce: announce,
    live: live,
    priceInCheckoutButton: priceInCheckoutButton,
    bumpCount: bumpCount,
    bindAll: bindAll,
    hidePeek: hidePeek
  };
})();
